import { useEffect, useState } from "react";
import { Permissions } from "@repo/database";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { SideNav } from "~/components/layout/side-nav";
import { useNavigationManager } from "~/managers/use-navigation-manager";
import { usePermissionManager } from "~/managers/use-permission-manager";
import { usePermissionStore } from "~/stores/use-permission-store";

export const Route = createFileRoute("/_main/settings/_layout")({
  component: SettingsLayout,
});

function SettingsLayout() {
  const { t } = useTranslation("common");

  const { settingsNavItems } = useNavigationManager();

  const { hasPermission } = usePermissionManager();

  const { currentEmployee } = usePermissionStore();

  const [permission, setPermission] = useState(false);

  useEffect(() => {
    if (!currentEmployee) {
      setPermission(false);
    }
    hasPermission({
      requiredPermission: Permissions.view_settings,
      label: t("Permissions.view_settings_label"),
    })
      .then((result) => {
        setPermission(result.permission);
      })
      .catch((e) => console.error(e));
  }, [hasPermission, currentEmployee, t]);

  if (!permission) return null;

  return (
    <div className="flex flex-col lg:flex-row h-full w-full">
      <SideNav title={t("settings")} navItems={settingsNavItems} />
      <div className="w-full overflow-auto">
        <div className="mx-auto max-w-3xl 2xl:max-w-7xl p-2 flex flex-col gap-2">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
